<template>
    <vx-dropdown placement="right">
        <vx-button type="button" color="muted" outline class="vx-w-[45px]">
            <font-awesome-icon :icon="faEllipsis" />
        </vx-button>

        <template v-slot:items>
            <vx-dropdown-item
                v-if="!props.segment.is_template && !props.segment.group_id"
                :href="`/contacts/segments/${props.segment.id}/contacts`"
            >
                View Contacts
                <font-awesome-icon :icon="faAddressBook"></font-awesome-icon>
            </vx-dropdown-item>

            <segment-row-export
                v-if="!props.segment.is_template && !props.segment.group_id"
                :segmentId="props.segment.id"
            ></segment-row-export>
            <vx-dropdown-item v-if="isStatic" @click="refreshSegment()">
                Refresh
                <font-awesome-icon :icon="faArrowsRotate"></font-awesome-icon>
            </vx-dropdown-item>
            <vx-dropdown-item
                :href="
                    props.segment.is_template
                        ? `/contacts/segments/templates/new?duplicateFromId=${props.segment.id}`
                        : `/contacts/segments/new?duplicateFromId=${props.segment.id}`
                "
                data-test="segment-duplicate-action"
            >
                Duplicate
                <font-awesome-icon :icon="faCopy"></font-awesome-icon>
            </vx-dropdown-item>
            <vx-dropdown-item @click="deleteSegment()">
                Delete
                <font-awesome-icon :icon="faTrash"></font-awesome-icon>
            </vx-dropdown-item>
        </template>
    </vx-dropdown>
</template>

<script setup>
import { faAddressBook, faArrowsRotate, faCopy, faEllipsis, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxDropdown, VxDropdownItem, VxSwal } from '@voxie/frontend-components';
import { useToasted } from '../../../composables/useToasted';
import segmentsClient from '~/services/segmentsClient';
import { SegmentType } from '../../../constants/segment';
import { computed } from 'vue';
import SegmentRowExport from './SegmentRowExport.vue';
import { throwSwalRequestError } from '~/utils/request';

const isStatic = computed(() => props.segment.type === SegmentType.STATIC);
const toasted = useToasted();

const teamId = Spark.state.currentTeam.id;

const props = defineProps({
    segment: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['deleted']);

const refreshSegment = async () => {
    try {
        await segmentsClient.refreshSegment(teamId, props.segment.id);

        toasted.success('Segment refresh started successfully.');
    } catch (error) {
        console.error(error);
        toasted.global.platform_error();
    }
};

const deleteSegment = () => {
    VxSwal.confirmation(
        'Delete Segment',
        'Are you sure? This segment and its association to contacts will be deleted. There is no undo.',
        'danger',
        () =>
            (props.segment.group_id
                ? segmentsClient.deleteGroupSegment(teamId, props.segment.group_id, props.segment.id)
                : segmentsClient.deleteSegment(teamId, props.segment.id)
            )
                .then(() => emit('deleted', props.segment.id))
                .catch(throwSwalRequestError)
    );
};
</script>
